/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_No_Records_PromptInputs */

const en_automatic_save_no_records_prompt = /** @type {(inputs: Automatic_Save_No_Records_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please reload records to start`)
};

const fr_automatic_save_no_records_prompt = /** @type {(inputs: Automatic_Save_No_Records_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez recharger les enregistrements pour commencer`)
};

const de_automatic_save_no_records_prompt = /** @type {(inputs: Automatic_Save_No_Records_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte laden Sie die Datensätze neu, um zu beginnen.`)
};

const it_automatic_save_no_records_prompt = /** @type {(inputs: Automatic_Save_No_Records_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricarica i record per iniziare`)
};

const ru_automatic_save_no_records_prompt = /** @type {(inputs: Automatic_Save_No_Records_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, обновите записи, чтобы начать.`)
};

const es_automatic_save_no_records_prompt = /** @type {(inputs: Automatic_Save_No_Records_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor recargue los registros para comenzar`)
};

const zh_cn2_automatic_save_no_records_prompt = /** @type {(inputs: Automatic_Save_No_Records_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请重新加载记录以开始`)
};

const ja_automatic_save_no_records_prompt = /** @type {(inputs: Automatic_Save_No_Records_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始するにはレコードを再読み込みしてください`)
};

const hi_automatic_save_no_records_prompt = /** @type {(inputs: Automatic_Save_No_Records_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया रिकॉर्ड पुनः लोड करें`)
};

const pt_pt2_automatic_save_no_records_prompt = /** @type {(inputs: Automatic_Save_No_Records_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, recarregue os registros para começar.`)
};

/**
* | output |
* | --- |
* | "Please reload records to start" |
*
* @param {Automatic_Save_No_Records_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_no_records_prompt = /** @type {((inputs?: Automatic_Save_No_Records_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_No_Records_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_save_no_records_prompt(inputs)
	if (locale === "de") return de_automatic_save_no_records_prompt(inputs)
	if (locale === "it") return it_automatic_save_no_records_prompt(inputs)
	if (locale === "ru") return ru_automatic_save_no_records_prompt(inputs)
	if (locale === "es") return es_automatic_save_no_records_prompt(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_save_no_records_prompt(inputs)
	if (locale === "ja") return ja_automatic_save_no_records_prompt(inputs)
	if (locale === "hi") return hi_automatic_save_no_records_prompt(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_save_no_records_prompt(inputs)
	return en_automatic_save_no_records_prompt(inputs)
});